import React, { useState } from 'react';
import styles from './HeaderUserMenu.module.scss';
import { useIsMobile, useUser } from '@/hooks';
import clsx from 'clsx';
import useClickOutside from '@/hooks/ui/useClickOutside';
import { ReactComponent as TriangleDown } from '@/assets/icons/navigation/triangle-down.svg';
import { UserAvatar } from '@/components/common/UserAvatar/UserAvatar';
import { MenuContent } from './MenuContent/MenuContent';
import { EUserAvatarSize } from '@/models';
type HeaderUserMenuProps = {
  showMenu?: boolean;
  passAvatarSize?: EUserAvatarSize;
  isModal?: boolean;
};
export const HeaderUserMenu: React.FC<HeaderUserMenuProps> = ({
  showMenu = true,
  passAvatarSize,
  isModal = false,
}) => {
  const { user } = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useClickOutside<HTMLDivElement>(() => setIsOpen(false));
  const { isTabletOrSmaller } = useIsMobile();

  const toggleMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };
  const avatarSize = isTabletOrSmaller
    ? EUserAvatarSize.small
    : EUserAvatarSize.medium;

  return (
    <div className={styles.headerUserMenuWrapper} onClick={toggleMenu}>
      <UserAvatar size={passAvatarSize ?? avatarSize} />
      <div
        className={clsx(
          styles.userDisplayName,
          isModal && styles.userDisplayNameInModal
        )}
      >
        {user.displayName || user.email}
      </div>
      {showMenu && (
        <>
          <div className={styles.menuToggle}>
            <TriangleDown className={styles.menuToggleIcon} />
          </div>

          <div className={clsx(styles.menu, isOpen && styles.isOpen)} ref={ref}>
            <MenuContent />
          </div>
        </>
      )}
    </div>
  );
};
